<template>
  <section class="quotes--quote-header">
    <fixed-header :title="pageTitle" :listPage="'/quotes'">
      <template v-slot:center>
        <a class="mr-2">Contact</a>
        <div class="edit-contact-container mr-1">
          <edit-contact :companyId="quote.companyId" :inlineButton="true" ref="editModal"
            @created="onContactCreated"></edit-contact>
        </div>
        <b-form-select class="w-auto mr-5" v-model="quote.contactId">
          <option v-for="(select, index) in sortSelect(contacts,'firstName')" :key="index" :value="select.id">
            {{ select.firstName + ' ' + select.lastName }}</option>
        </b-form-select>
        <h6 class="mb-0 mr-2">Status:</h6>
        <a class="mr-5">{{ quote.statusName }}</a>
        <a class="mr-2">Sales Rep</a>
        <b-form-select v-model="quote.salesPersonId" class="w-auto mr-5">
          <option v-for="(selectRep, indexRep) in sortSelect(salesReps)" :key="indexRep" :value="selectRep.id">
            {{ selectRep.name }}
          </option>
        </b-form-select>
        <span v-if="quote.authorizedByUserFullName && quote.dateAuthorized" class="ml-3">
          <h6 class="mb-0 mr-2">Authorized by:</h6>
          <a class="mr-2">{{ quote.authorizedByUserFullName + ' on ' + quote.dateAuthorized }}</a>
        </span>
        <span v-if="quote.dateEmailed" class="ml-3">
          <h6 class="mb-0 mr-2">Mailed at:</h6>
          <a class="mr-2">{{ quote.dateEmailed }}</a>
        </span>

      </template>
    </fixed-header>

    <b-card class="quotes-header mb-1">
      <div class="d-flex">
        <address-selector
          @input="quote.billingAddressId=$event.id, quote.billingAddress=$event.newAddr"
          :value="quote.billingAddress"
          :addressId="quote.billingAddressId"
          title="Bill to"
          width="300"
          :accountId="quote.companyId"
          class="mr-4"
        />
        <address-selector
          @input="quote.shippingAddressId=$event.id, quote.shippingAddress=$event.newAddr"
          :value="quote.shippingAddress"
          :addressId="quote.shippingAddressId"
          title="Ship to"
          width="300"
          :accountId="quote.companyId"
          class="mr-4"
        />
        <div class="d-flex flex-column header-field-width mr-3">
          <b-form-group label-cols="4" label-align="right" label="Date">
            <date-picker v-model="quote.quoteDate" :config="datePickerOptions"></date-picker>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Terms" class="required">
            <b-form-select v-model="quote.quoteTermId" :class="{ 'is-invalid': $v.quote.quoteTermId.$error }">
              <option v-for="(select, index) in sortSelect(quoteTerms)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>          
          <b-form-group label-cols="4" label-align="right" label="Inco Terms" class="required">
            <b-form-select v-model="quote.incoTermId" :class="{ 'is-invalid': $v.quote.incoTermId.$error }">
              <option v-for="(type) in sortSelect(incoTerms)" :key="type.id" :value="type.id">{{type.name}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Sale Type">
            <b-form-select v-model="quote.salesTypeId">
              <option v-for="(type) in sortSelect(salesTypes)" :key="type.id" :value="type.id">{{type.name}}</option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="d-flex flex-column header-field-width mr-3">
          <b-form-group label-cols="4" label-align="right" label="Ship Via" class="required">
            <b-form-select v-model="quote.shippingProviderId" @change="onShippingAccountChange(true)" :class="{ 'is-invalid': $v.quote.shippingProviderId.$error }">
              <option v-for="(select, index) in sortSelect(shippingProviders)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Ship Method" :class="{ 'required': this.isRequiredShipDetails }">
            <b-form-select v-model="quote.shippingMethodId" :class="{ 'is-invalid': $v.quote.shippingMethodId.$error }">
              <option v-for="(select, index) in sortSelect(shipMethods)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <!-- <b-form-group label-cols="4" label-align="right" label="Customer Pays Shipping">
            <b-form-checkbox v-model="quote.shipOnCompanyAccount" class="mt-2" />
          </b-form-group> -->
          <b-form-group label-cols="4" label-align="right" label="Ship On" :class="{ 'required': this.isRequiredShipDetails }">
              <b-form-select v-model="quote.alwaysShipBy" @change="onShippingAccountChange(false)" :class="{ 'is-invalid': $v.quote.alwaysShipBy.$error }">
                <option value="0"></option>
                <option value="1">Customer</option>
                <option value="2">House Account</option>
              </b-form-select>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Ship Acct #">
            <b-input-group size="sm">
              <b-form-input v-model="quote.shippingAccountNumber" />
            </b-input-group>
          </b-form-group>
          <!-- <b-form-group label-cols="4" label-align="right" label="Tracking No.">
            <b-input-group size="sm">
              <b-form-input v-model="quote.trackingNumber" />
            </b-input-group>
          </b-form-group> -->
        </div>
      </div>
    </b-card>
  </section>
</template>

<script>
  import {
    mapGetters,
    mapActions,
    mapState
  } from 'vuex';
  import moment from 'moment';
  import {
    DATE_FORMAT,
    US_DOLLARS_CURRENCY_ID,
    EXCHANGE_RATE_DEFAULT
  } from '@/shared/constants';
  //import { GRID_ID, SAVE_SETTINGS_DELAY } from '@/shared/constants';

  import EditContact from '@/pages/Company/components/CompanyDetails/tabs/Contacts/components/EditContact/index';
  //import EditAddress from '@/pages/Company/components/CompanyDetails/tabs/Addresses/components/EditAddress/index';
  import AddressSelector from '@/shared/components/AddressSelector/index';
  import FixedHeader from '@/shared/components/FixedHeader/indexNew';
  import { required, requiredIf, minValue } from 'vuelidate/lib/validators';
  const isMinValue = function(val) { return this.isRequiredShipDetails ? val > 0 : val >= 0; }

  export default {
    components: {
      EditContact,
      //EditAddress,
      AddressSelector,
      FixedHeader,
    },
    data() {
      return {
        text: '11111111',

        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
      }
    },
    watch: {
      async quote() {
        if(this.quote.quoteDate) {
          this.quote.quoteDate = moment(this.quote.quoteDate).format(DATE_FORMAT);
        }

        if(this.quote.dateAuthorized) {
          this.quote.dateAuthorized = moment(this.quote.dateAuthorized).format(DATE_FORMAT);
        }

        if(this.quote.dateEmailed) {
          this.quote.dateEmailed = moment(this.quote.dateEmailed).format(DATE_FORMAT);
        }
      },
    },
    computed: {
      ...mapState('salesReps', ['salesReps']),
      // ...mapState('quoteDetails', [
      //   'quotes',
      // ]),
      ...mapGetters('lookup', ['salesTypes', 'incoTerms', 'currencies', 'shippingProviders', 'shipViaList', 'houseShippingAccounts']),
      ...mapGetters('quoteDetails', [
        // 'chargesById',
        'quoteById',
        'contacts',
        'quoteTerms',
        // 'quoteStatuses',
      ]),
      ...mapGetters('account', ['userId']),
      ...mapGetters('companies', ['companyById']),
      ...mapGetters('shippingAccount', ['shippingAccountsList']),
      pageTitle() {
        return `Quote No. ${this.quoteId} - ${this.quote.companyName}`;
      },
      quoteId() {
        return this.$route.params.id;
      },
      quote() {
        // return this.quotes[this.quoteId];
        return this.quoteById(this.quoteId);
      },
      company() {
        var result = this.companyById(this.quote.companyId);
        return result;
      },
      status() {
        var rtn = '';
        switch (this.quote.statusId) {
          case 1:
            rtn = 'OPEN';
            break;
          case 2:
            rtn = 'WON';
            break;
          case 3:
            rtn = 'LOST';
            break;
          default:
            rtn = '';
            break;
        }
        return rtn;
      },
      shipMethods() {
        if (this.quote.shippingProviderId) {
          return this.shipViaList.filter(ship => ship.shippingProviderId == this.quote.shippingProviderId);
        } else {
          return [];
        }
      },
      isRequiredShipDetails() {
        return (this.shippingProviders.length > 0 && this.quote) ? this.shippingProviders.filter(prov => prov.name != "TBD" && prov.name != "Unassigned")
          .map(x => x.id).includes(this.quote.shippingProviderId) : false;
      }
    },
    methods: {
      ...mapActions('salesReps', ['getSalesReps']),
      ...mapActions('companies', { getCompanyById: 'getById' }),
      ...mapActions('quoteDetails', [
        'getById',
        'getQuoteTerms',
        'getQuoteStatuses',
        'getContacts',
        'toggleQuoteStatus',
      ]),
      ...mapActions('shippingAccount', ['getShippingAccounts']),
      async onContactCreated(id) {
        await this.getContacts(this.quote.companyId);
        this.quote.contactId = id;
      },
      async onToggleQuoteStatus() {
        await this.toggleQuoteStatus(this.quoteId);

        await this.getById(this.quoteId);
      },
      onShippingAccountChange(isProviderChange = false) {
        if (isProviderChange) {
          let prov = this.shippingProviders.find(x => x.id == this.quote.shippingProviderId);
          if (prov && prov.name == "TBD") {
            // auto set method if the provider is TBD
            let sMthd = this.shipViaList.find(x => x.shippingProviderId == this.quote.shippingProviderId);
            this.quote.shippingMethodId = (sMthd) ? sMthd.id : 0;
            
          } else {
            this.quote.shippingMethodId = 0;
          }
        }
        let shipAccts = null;

        // If ship by is Customer
        if (this.quote.alwaysShipBy == 1) {
          shipAccts = this.shippingAccountsList.find(x => x.shippingProviderId == this.quote.shippingProviderId);
        } else if (this.quote.alwaysShipBy == 2) {
          shipAccts = this.houseShippingAccounts.find(x => x.shippingProviderId == this.quote.shippingProviderId);  
        } 

        this.quote.shippingAccountNumber = shipAccts != null ? shipAccts.accountNumber : null;
      },
      getHeaderValidation() {
        this.$v.$touch();
        this.$emit('header-validation', this.$v.$invalid);
      },
    },
    validations: {
      quote: {
        incoTermId: {required},
        quoteTermId: {required},
        shippingProviderId: {required},
        shippingMethodId: { 
          required: requiredIf(function() { return this.isRequiredShipDetails }),
          isMinValue
        },
        alwaysShipBy: {
          required: requiredIf(function(){ return this.isRequiredShipDetails } ),
          isMinValue

        },
      }
    },
    async mounted() {
      // await this.getById(this.quoteId);
      await this.getQuoteTerms();
      await this.getQuoteStatuses();
      // await this.getContacts(this.quote.companyId);
      await this.getSalesReps();

      if(this.quote.dateAuthorized) {
        this.quote.dateAuthorized = moment(this.quote.dateAuthorized).format(DATE_FORMAT);
      }

      if(this.quote.dateEmailed) {
        this.quote.dateEmailed = moment(this.quote.dateEmailed).format(DATE_FORMAT);
      }

      if (this.quote.salesPersonId == null) {
        this.quote.salesPersonId = this.userId;
      }

      if (!this.quote.currencyTypeId) {
        this.quote.currencyTypeId = US_DOLLARS_CURRENCY_ID;
        this.quote.exchangeRate = EXCHANGE_RATE_DEFAULT;
      }

      if (this.quote.companyId) {
        this.getShippingAccounts(this.quote.companyId);
        this.getContacts(this.quote.companyId);
        if (Object.keys(this.company).length == 0) {
          this.getCompanyById(this.quote.companyId);
        }
      }
    },
  };

</script>

<style lang="scss">
  .quotes-header-icons {
    font-size: 22px;
  }

  .quotes--quote-header {
    .contact-label {
      display: contents;
    }

    .edit-contact-container {
      text-align: right;
    }

    .contact-header {
      display: flex;
      justify-content: space-between;
    }

    .edit-contact-container {
      button {
        font-size: 6px;
        margin-bottom: 5px;
      }
    }

    .status {
      display: inline;
      padding-right: 6px;
    }
  }

</style>
